<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          基于人工智能的电系操作指令票自动识别
        </div>
        <div class="txt">
          Artificial intelligence-based automatic recognition of electrical system operation instruction tickets
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>基于人工智能的电系操作指令票的系统，该系统已于2021年6月在上海市电力公司市北供电公司内进行了应用试验。其案例识别流。</p>
        </div> 
      </div>
      <div>
        <div class="title">软件应用图示</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img41.png" alt="">
            <div class="txt">
              图一：系统首页
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img42.png" alt="">
            <div class="txt">
              图二：使用高拍仪对电系操作指令票进行拍照识别
            </div>
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img43.png" alt="">
            <div class="txt">
              图三：展示数据库中的关键字匹配库列表
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img44.png" alt="">
            <div class="txt">
              图四：查看生成的操作票文件
            </div>
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 250px;

  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 460px;
  height: 260px;
}
.list_one {
  margin-bottom: 20px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}
.detail_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail3.vue